<template>
    <div>
        <div :id="chartId" style="width: 350px; height: 300px"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts/dist/echarts.js';

    export default {
        props: {
            chartId: {
                type: String
            },
            itemInfo: {
                type: Object
            },
            seriesData: {
                type: Array
            },
            outlierData: {
                type: Array
            }
        },
        data() {
            return {
                series: [25, 29, 32, 35, 38],
                chartOptions: null,
                my_chart: null,
                chart_option: null
            }
        },
        computed: {
            chartOpts() {
                return {
                    series: [
                        {
                            data: this.seriesData,
                            type: 'boxplot',
                            boxWidth: ['30%', '40%'] // min max
                        },
                        {
                            data: [...this.outlierData],
                            type: 'scatter'
                        }
                    ]
                }
            }
        },
        methods: {
            refreshComponent() {
                this.my_chart.resize()
            },
            applyResize() {
                let chart = document.querySelector(this.chartId)
                let chart_parent = chart.parentElement
                chart_parent.handleResize = entry => {
                    console.log('entry.borderBoxSize[0].inlineSize', entry.borderBoxSize[0].inlineSize)
                }
            },
            initChart() {
                var self = this
                console.log('this itemInfo', this.itemInfo)
                this.my_chart = echarts.init(document.getElementById(this.chartId))
                this.chart_option = {
                    xAxis: {
                        show: true,
                        type: 'category',
                        data: [this.itemInfo.label]
                    },
                    yAxis: {
                        show: true,
                        type: 'value',
                    },
                    grid: { 
                        show: false,
                        top: '30',
                        right: '10',
                        bottom: '10',
                        left: '10',
                        containLabel: true
                    },
                    series: this.chartOpts.series,
                    legend: { show: false }
                };

                this.my_chart.setOption(this.chart_option);
                // this.applyResize()
            },
            updateChart() {
                this.my_chart.setOption(this.chartOpts);
            }
        },
        mounted () {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.initChart()
                    this.$_screenResizeRefresh();
                }, 100);
            })
        },
        watch: {
            seriesData() {
                this.updateChart()
            },
            outlierData() {
                this.updateChart()
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Analytics/ExpandMiniBoxPlotChart2.vue